// placement status
const PLACEMENT_STATUS_ACTIVE = 'active';
const PLACEMENT_STATUS_CANCELLED = 'cancelled';
const PLACEMENT_STATUS_INVITED = 'pendingEmployeeAcceptance';
const PLACEMENT_STATUS_APPLIED = 'pendingEmployerApproval';

const GEOLOCATION_STATUS_PROMPT = 'prompt';

const GEOLOCATION_STATUS_GRANTED = 'granted';

const GEOLOCATION_STATUS_DENIED = 'denied';

module.exports = {
  PLACEMENT_STATUS_ACTIVE,
  PLACEMENT_STATUS_CANCELLED,
  PLACEMENT_STATUS_INVITED,
  PLACEMENT_STATUS_APPLIED,
  GEOLOCATION_STATUS_PROMPT,
  GEOLOCATION_STATUS_GRANTED,
  GEOLOCATION_STATUS_DENIED,
};
